<template>
<loader v-bind="{ loading }">
  <div class="box">
    <columns v-for="invite in invites" :key="invite.id">
      <column>
        <p class="is-size-4">{{ invite.team.name }}</p>
      </column>
      <column class="is-narrow">
        <div class="buttons has-addons">
          <action-button @click="acceptInvite(invite)" class="is-success">Accept Invitation</action-button>
          <action-button @click="declineInvite(invite)" class="is-danger">Decline Invitation</action-button>
        </div>
      </column>
    </columns>
  </div>
</loader>  
</template>
<script>
import { get, post } from '@/api/request'
export default {
  
  data: () => ({
    loading: true,
    invites: []
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Team Invites')
    get('api/invitations', ({data}) => {
      this.invites = data
      this.loading = false
    })
  },

  methods: {
    acceptInvite(invite) {
      post(`api/invitation/${invite.id}/accept`, {}, () => {
        this.$toast.success('Invite accepted')
        this.$router.push('/')
      })
    },
    async declineInvite(invite) {
      if(await this.$confirm({
        title: 'Decline',
        message: 'Are you sure you want to decline this invitation?'
      })) {
        post(`api/invitation/${invite.id}/decline`, {}, () => {
          this.$toast.success('Invite declined')
          this.$router.push('/')
        })
      }
    },
  }

}
</script>